export default __webpack_public_path__ + "static/media/SparkleBottom.1441c48f.svg";